import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'

import { store } from '@/store/store.js';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

Vue.use(Router)


import Contacto from '@/components/views/contacto'
import datosSeguridadSocial from '@/components/views/datos-seguridad-social'
import politicaPrivacidadSeguridadSocial from '@/components/views/politica-privacidad-seguridad-social'


const encuestas = () => import('@/components/views/encuestas');
const fichaencuesta = () => import('@/components/views/ficha-encuesta');

import cv from '@/components/views/cv';

import ofertas from '@/components/views/listado-ofertas';
import fichaoferta from '@/components/views/ficha-oferta';

const eventos = () => import('@/components/views/listado-eventos');
const fichaevento = () => import('@/components/views/ficha-evento');
const orientacionprofesional = () => import('@/components/views/orientacion-profesional');
const testimonios = () => import('@/components/views/testimonios');
const candidaturas = () => import('@/components/views/candidaturas');
const practicasasignadas = () => import('@/components/views/practicas-asignadas');
const candidatos = () => import('@/components/views/empresas/listado-candidatos');

const informaciongeneral = () => import('@/components/views/informacion-general');
const estudiaytrabaja = () => import('@/components/views/estudia-y-trabaja');
const internacional = () => import('@/components/views/internacional');
const altaEstudiantes = () => import('@/components/views/registro-estudiantes');
const firmaredirect = () => import('@/components/views/firma-redirect');


const  misofertas = () => import('@/components/views/empresas/mis-ofertas');
const  mioferta = () => import('@/components/views/empresas/ficha-oferta');
const  editoroferta = () => import('@/components/views/empresas/editor-oferta');
const  nuevaEmpresa = () => import('@/components/views/empresas/nueva-empresa');
const  busquedaCarta = () => import('@/components/views/empresas/busqueda-carta');
const  fichaBusquedaCarta = () => import('@/components/views/empresas/ficha-busqueda');
const  nuevabusquedaCarta = () => import('@/components/views/empresas/nueva-busqueda-carta');
const  miperfil = () => import('@/components/views/empresas/mi-perfil');
const  nuevocontacto = () => import('@/components/views/empresas/nuevo-contacto');
const  establecerlogin = () => import('@/components/views/empresas/establecer-login');
const  propuestapracticasempresa = () => import('@/components/views/empresas/propuesta-practicas');
const  propuestapracticas = () => import('@/components/views/propuesta-practicas');


import logout from '@/components/views/logout';
import login from '@/components/views/login';

import Error404 from '@/components/views/error-404'

import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'

Vue.use(Router)


import messages from '@/translations';

let es = messages.es.enlaces;
let titles = messages.es.titles;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				requiresAuth: true,
				title: titles.home
			}
		},
		{
			path: es.empresas,
			name: 'empresas-public-home',
			component: Home,
			meta: {
				requiresAuth: false,
				title: titles.home
			}
		},
		{
			path: `${es.ofertas}/:filtro?`,
			name: 'ofertas',
			component: ofertas,
			meta: {
				requiresAuth: true,
				usertype : 'isCandidato',
				title: titles.ofertas
			}
		},
		{
			path: `${es.oferta}/:id?`,
			name: 'ficha-oferta',
			component: fichaoferta,
			meta: {
				requiresAuth: true,
				usertype : 'isCandidato',
				title: titles.oferta
			}
		},
		{
			path: `${es.programaindependiente}/:id?`,
			name: 'ficha-oferta-programa-independiente',
			component: fichaoferta,
			meta: {
				requiresAuth: true,
				usertype : 'isCandidato',
				title: titles.oferta
			}
		},
		{
			path: `${es.cv}/:id?`,
			name: 'cv',
			component: cv,
			meta: {
				requiresAuth: true,
				title: titles.cv
			}
		},
		{
			path: es.encuestas,
			name: 'encuestas',
			component: encuestas,
			meta: {
				requiresAuth: true,
				title: titles.encuestas
			}
		},
		{
			path: `${es.encuesta}/:id?`,
			name: 'encuesta',
			component: fichaencuesta,
			meta: {
				requiresAuth: false,
				title: titles.encuesta
			}
		},
		{
			path: es.eventos,
			name: 'eventos',
			component: eventos,
			meta: {
				requiresAuth: true,
				title: titles.eventos
			}
		},
		{
			path: `${es.evento}/:id?`,
			name: 'ficha-evento',
			component: fichaevento,
			meta: {
				requiresAuth: true,
				title: titles.evento
			}
		},
		{
			path: es.orientacionprofesional,
			name: 'orientacionprofesional',
			component: orientacionprofesional,
			meta: {
				requiresAuth: false,
				title: titles.orientacionprofesional
			}
		},
		{
			path: es.internacional,
			name: 'internacional',
			component: internacional,
			meta: {
				requiresAuth: false,
				usertype : 'isCandidato',
				title: titles.internacional
			}
		},
		{
			path: es.estudiaytrabaja,
			name: 'estudiaytrabaja',
			component: estudiaytrabaja,
			meta: {
				requiresAuth: true,
				title: titles.estudiaytrabaja
			}
		},
		{
			path: es.candidaturas,
			name: 'candidaturas',
			component: candidaturas,
			meta: {
				requiresAuth: true,
				title: titles.candidaturas,
				usertype : 'isCandidato',
			}
		},
		{
			path: es.practicasasignadas,
			name: 'practicasasignadas',
			component: practicasasignadas,
			meta: {
				requiresAuth: true,
				title: titles.practicasasignadas,
				usertype : 'isEstudiante',
			}
		},
		{
			path: es.propuestapracticasempresa,
			name: 'propuestapracticasempresa',
			component: propuestapracticasempresa,
			meta: {
				requiresAuth: true,
				title: titles.practicasasignadas,
				usertype : 'isEmpresa',
			}
		},
		{
			path: es.propuestapracticas,
			name: 'propuestapracticas',
			component: propuestapracticas,
			meta: {
				requiresAuth: true,
				title: titles.practicasasignadas,
				usertype : 'isEstudiante',
			}
		},
		{
			path: es.testimonios,
			name: 'testimonios',
			component: testimonios,
			meta: {
				requiresAuth: false,
				title: titles.testimonios
			}
		},
		{
			path: es.informaciongeneral,
			name: 'informaciongeneral',
			component: informaciongeneral,
			meta: {
				requiresAuth: false,
				title: titles.informaciongeneral,
			}
		},
		{
			path: es.datos_seguridad_social,
			name: 'datosseguridadsocial',
			component: datosSeguridadSocial,
			meta: {
				requiresAuth: false,
				title: titles.datos_seguridad_social,
			}
		},
		{
			path: es.politica_privacidad_seguridad_social,
			name: 'politicaprivacidadseguridadsocial',
			component: politicaPrivacidadSeguridadSocial,
			meta: {
				requiresAuth: false,
				title: titles.politica_privacidad_seguridad_social,
			}
		},
		{
			path: es.contacto,
			name: 'contacto',
			component: Contacto,
			meta: {
				requiresAuth: false,
				title: titles.contacto
			}
		},
		{
			path: `${es.misofertas}/:id?`,
			name: 'misofertas',
			component: misofertas,
			meta: {
				requiresAuth: true,
				title: titles.misofertas,
				usertype : 'isEmpresa',
			}
		},
		{
			path: `${es.mioferta}/:id`,
			name: 'mioferta',
			component: mioferta,
			meta: {
				requiresAuth: true,
				usertype : 'isEmpresa',
				title: titles.mioferta
			}
		},
		{
			path: `${es.editaroferta}/:id?`,
			name: 'editar-oferta',
			component: editoroferta,
			meta: {
				requiresAuth: true,
				usertype : 'isEmpresa',
				title: titles.nuevaoferta
			}
		},
		{
			path: `${es.nuevaoferta}/:id?`,
			name: 'nueva-oferta',
			component: editoroferta,
			meta: {
				requiresAuth: true,
				usertype : 'isEmpresa',
				title: titles.nuevaoferta
			}
		},
		{
			path: es.nuevaempresa,
			name: 'nueva-empresa',
			component: nuevaEmpresa,
			meta : {
				requiresAuth : false,
				title : titles.nuevaempresa
			}
		},
		{
			path: `${es.nuevocontacto}/:id?`,
			name: 'nueva-contacto',
			component: nuevocontacto,
			meta : {
				requiresAuth : true,
				title : titles.nuevocontacto
			}
		},
		{
			path: es.busquedaCarta,
			name: 'busqueda-carta',
			component: busquedaCarta,
			meta : {
				requiresAuth : true,
				usertype : 'isEmpresa',
				title : titles.busquedaCarta
			}
		},
		{
			path: es.nuevabusquedacarta,
			name: 'nueva-busqueda-carta',
			component: nuevabusquedaCarta,
			meta : {
				requiresAuth : true,
				usertype : 'isEmpresa',
				title : titles.busquedaCarta
			}
		},
		{
			path: `${es.busquedaCarta}/:id?`,
			name: 'busqueda-carta',
			component: fichaBusquedaCarta,
			meta : {
				requiresAuth : true,
				usertype : 'isEmpresa',
				title : titles.busquedaCarta
			}
		},
		{
			path: es.altaestudiantes,
			name: 'alta-estudiantes',
			component: altaEstudiantes,
			meta : {
				requiresAuth : false,
				title : titles.altaestudiantes
			}
		},
		{
			path: `${es.candidatos}/:id?`,
			name: 'candidatos',
			component: candidatos,
			meta : {
				requiresAuth : true,
				usertype : 'isEmpresa',
				title : titles.candidatos
			}
		},
		{
			path: `${es.miperfil}/:id?`,
			name: 'miperfil',
			component: miperfil,
			meta : {
				requiresAuth : true,
				usertype : 'isEmpresa',
				title : titles.miperfil
			}
		},
		{
			path: es.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad,
			meta : {
				requiresAuth : false,
				title : titles.politica_privacidad
			}
		},
		{
			path: es.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies,
			meta: {
				requiresAuth: false,
				title: titles.politica_cookies
			}
		},
		{
			path: es.logout,
			name: 'logout',
			component: logout,
			meta: {
				requiresAuth: false,
				title: titles.logout
			}
		},
		{
			path: es.establecerlogin,
			name: 'establecerlogin',
			component: establecerlogin,
			meta: {
				requiresAuth: false,
				title: titles.logout
			}
		},
		{
			path: `${es.firmaredirect}/:id?`,
			name: 'firmaredirect',
			component: firmaredirect,
			meta: {
				requiresAuth: false,
				title: titles.firmaredirect
			}
		},
		{
			path: `${es.login}/:id?`,
			name: 'login',
			component: login,
			meta: {
				requiresAuth: false,
				title: titles.login
			}
		},
		{ path: '*', redirect: '/' },
		{ path: "/404", component: Error404 }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
	id: 'UA-87588846-1',
	router,
	debug: { sendHitTask: location.hostname.includes('practicasyempleoufv.es') }
});

router.beforeEach((to, from, next) => {

	//SETEO DEL TITLE
	if(!!to.meta.title){	
		document.title = "Portal Empleo UFV para estudiantes y para alumni";
	}

	//COMPRUEBO INICIO DE SESIÓN Y SI ESTÁ LOGADO
	if (to.matched.some(route => route.meta.requiresAuth) && !store.getters.getLogged) {

		if(!!to.path){
			window.sessionStorage.setItem('pushto', to.path);
		}

		next({ name: 'login' })
		return
	}

	//COMPRUEBO SI TIENE SESIÓN INICIADA Y LE LLEVO A LA HOME
	if ((to.path.indexOf('/login') != -1) && store.getters.getLogged) {
		next({ name: 'home' })
		return
	}

	//COMPRUEBO SI EL DESTINO SE ASOCIA CON SU PERFIL
	if(to.matched.some(route => route.meta.usertype)){

		setTimeout(e => {
			if(!store.getters[`${to.meta.usertype}`]){
				next({ name: 'home' });
				return
			}
		},100)
	
	}

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js